/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import AddProductForm from "../../components/AddProductForm";
import EditProductForm from "../../components/EditProductForm";
import { Modal } from "../../Shared/Modal";
import { useGetProductsQuery } from "../../Redux/api/productApi";
import ProductCard from "../../components/ProductCard";
import Pagination from "../../components/Pagination";
import { useGetCategoriesQuery } from "../../Redux/api/categoryApi";

const AgentProductsList = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const { data: categories } = useGetCategoriesQuery();
  console.log("categories", categories);
  const {
    data: productsData,
    isLoading,
    isError,
    error,
    isFetching,
  } = useGetProductsQuery({
    mine: true,
    page,
    page_size: pageSize,
    search,
    category: category || undefined,
  });

  const products = productsData?.results || [];
  const totalCount = productsData?.count || 0;
  const totalPages = Math.ceil(totalCount / pageSize);

  const handleProductAdded = () => {
    setIsAddModalOpen(false);
    setPage(1);
  };

  const handleProductUpdated = () => {
    setIsEditModalOpen(false);
    setSelectedProduct(null);
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl">Loading products...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl text-red-500">
          Error loading products:
          {error?.data?.message || "Something went wrong"}
        </div>
      </div>
    );
  }
  console.log("productsData", productsData);

  return (
    <div className="products-page">
      <div className="product-top-bar mb-6">
        <div>
          <p className="text-gray-600 mt-1 text-sm">
            {totalCount} {totalCount === 1 ? "Product" : "Products"} found
          </p>
        </div>
      </div>

      {isFetching && !isLoading && (
        <div className="text-center text-blue-600 mb-4 font-medium">
          Updating products...
        </div>
      )}

      {products.length === 0 && !isLoading && (
        <div className="text-center py-16">
          <div className="text-gray-400 text-6xl mb-4">""</div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No products found
          </h3>
          <p className="text-gray-500 mb-6">
            {search || category
              ? "Try adjusting your search or filters"
              : "Start by adding your first product"}
          </p>
          {!search && !category && (
            <button
              onClick={() => setIsAddModalOpen(true)}
              className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition"
            >
              Add Your First Product
            </button>
          )}
        </div>
      )}

      {products.length > 0 && (
        <div className="products-list-wrapper grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div className="mt-8 flex flex-col items-center gap-4">
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            maxVisiblePages={5}
          />
        </div>
      )}

      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        title="Add New Product"
        mw="max-w-2xl"
      >
        <AddProductForm
          onClose={() => setIsAddModalOpen(false)}
          onAdded={handleProductAdded}
        />
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedProduct(null);
        }}
        title="Edit Product"
        mw="max-w-2xl"
      >
        <EditProductForm
          onClose={() => setIsEditModalOpen(false)}
          onUpdated={handleProductUpdated}
        />
      </Modal>
    </div>
  );
};

export default AgentProductsList;
